//#region  IMPORTS
import { useEffect, useState, useMemo } from "react";

import Box from "@mui/material/Box";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {
  Container,
  ListItemIcon,
  Button,
  Typography,
  Chip,
  Tooltip,
  IconButton,
  Badge,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import { Mail, Undo } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";

import PendingActionsIcon from "@mui/icons-material/PendingActions";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CancelIcon from "@mui/icons-material/Cancel";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableChartIcon from "@mui/icons-material/TableChart";
import CloseIcon from "@mui/icons-material/Close";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";

// Custom imports
import { UrlApi } from "../../../../../services/apirest";
import ConfirmDialog from "../../../../Dialogs/ConfirmDialog";
import { getData, putData } from "../../../../../services/library";
import { logEventos, verEnviarPDF } from "../../../../../services/services";
import NewInvoiceDialog from "./NewInvoiceDialog";
import { fetchPermisos } from "../../../../../services/services";
import ReceiptDialog from "./recibos/UI/ReceiptDialog";
import SeleccionarRecibo from "./recibos/UI/Imputaciones/SeleccionarRecibo";
import ReciboDetalleContainer from "./recibos/UI/MostrarDetalleRecibo/ReciboDetalleContainer";
import SaldosFacturasModal from "./facturas/UI/SaldosFacturasModal";
import AnularRecibosModal from "./recibos/UI/anularRecibos/AnularRecibosModal";
import { useToast } from "../../../../../Hooks/UseToast";
import PendingReceiptsChip from "./recibos/UI/chipDeRecibosPendientes/PendingReceiptsChip";
import DesaplicarImputacionModal from "./recibos/desaplicaciones/components/DesaplicarImputacionModal";
import { DesaplicarFacturasModal } from "./facturas/desaplicaciones/components/DesaplicarFacturasModal";
import ModalDeFiltros from "./resumenDeCuenta/ModalDeFiltros";
import CuentaCorrientePendientesPage from "./soloPendientes/pages/CuentaCorrientePendientesPage";
import ImputacionModal from "./recibos/UI/Imputaciones/ImputacionModal";
import NotasCuentaCorrienteModal from "./notasCuentaCorriente/NotasCuentaCorriente";
//#endregion

function Comprobantes(props) {
  // console.log("Props: ", props);
  const { Toast, showToast } = useToast();
  const [documents, setDocuments] = useState(); //Comprobantes
  const [mailCliente, setMailCliente] = useState(null);
  const [showCancelReceiptsDialog, setShowCancelReceiptsDialog] =
    useState(false);
  const [showDesaplicarRecibo, setShowDesaplicarRecibo] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [showAnularFacturaDialog, setShowAnularFacturaDialog] = useState(false);
  const [showResendEmailConfirm, setShowResendEmailConfirm] = useState(false);
  const [showNewInvoiceDialog, setShowNewInvoiceDialog] = useState(false);
  const [showReceiptDialog, setShowReceiptDialog] = useState(false);
  const [permisos, setPermisos] = useState([]);
  const [totales, setTotales] = useState({ debe: 0, haber: 0, saldo: 0 });
  const [selectedRecibo, setSelectedRecibo] = useState();
  const [showReciboDetalle, setShowReciboDetalle] = useState(false);
  const [showNewImputacionDialog, setShowNewImputacionDialog] = useState(false);
  const [showSaldoFactura, setShowSaldoFactura] = useState(false);
  const [showModalDeFiltros, setShowModalDeFiltros] = useState(false);
  const [verSoloPendientes, setVerSoloPendientes] = useState(false);
  const [showNotesDialog, setShowNotesDialog] = useState(false);
  const [copiedId, setCopiedId] = useState(null);
  const [showAplicarReciboAFactura, setShowAplicarReciboAFactura] =
    useState(false);
  const [contadorDeNotas, setContadorDeNotas] = useState(0);

  const traerCantidadDeNotas = async () => {
    const response = await fetch(
      `${UrlApi}/cuentaCorriente/notas/count/${props.cliente.id}/0`,
    );
    if (!response.ok)
      throw new Error("Ocurrio un error al traer la cantidad de notas");

    const data = await response.json();

    setContadorDeNotas(data?.cantidad);
  };

  const [filtros, setFiltros] = useState({
    tipos: [],
    estado: null,
    soloPendientesDeAplicar: false,
    fechaInicio: null,
    fechaFin: null,
    ordenarDatos: "DESC",
    resumenesConDetalles: null,
  });
  const [exportTipo, setExportTipo] = useState(null);

  const [cantidadDeRecibosPendientes, setCantidadDeRecibosPendientes] =
    useState(0);

  const canCancelInvoice = localStorage.getItem("anula_facturas") === "1"; //Indica si el usuario tiene o no permiso para cancelar facturas con NC.
  const bgColorTableHeadCell = props.soloLectura
    ? "rgba(235, 235, 235, 0.8)"
    : "rgba(212, 230, 241, 0.8)";
  const iconCheck = <InfoIcon sx={{ fontSize: 40 }} />;

  const handleExportPdf = () => {
    setExportTipo("pdf");
    setShowModalDeFiltros(true);
  };

  const handleExportExcel = () => {
    setExportTipo("excel");
    setShowModalDeFiltros(true);
  };

  const handleShowSaldoFacturas = (rowInfo) => {
    setSelectedRow(rowInfo);
    setShowSaldoFactura(true);
  };

  const handleShowAnularFacturaDialog = (rowInfo) => {
    setSelectedRow(rowInfo);
    // console.log("ROWINFO :", rowInfo);
    setShowAnularFacturaDialog(true);
  };

  const handleShowDesaplicarRecibo = (rowInfo) => {
    setSelectedRecibo(rowInfo);
    setShowDesaplicarRecibo(true);
  };

  const handleShowModalDeFiltros = () => {
    setShowModalDeFiltros(true);
  };

  const getDocuments = () => {
    const query = buildQueryParams(filtros);

    fetch(
      `${UrlApi}/comprobantes/ledger/${props.cliente.id}/${props.cliente.id_tipocliente}?${query}`,
    )
      .then((data) => data.json())
      .then((data) => {
        setDocuments(data?.movimientos);
        setTotales({
          debe: data?.saldos?.debito,
          haber: data?.saldos?.credito,
          saldo: data?.saldos?.saldo,
        });
      });
  };

  async function obtenerPermisos() {
    const permisos = await fetchPermisos();
    setPermisos(permisos);
  }

  const buildQueryParams = (filtros) => {
    const params = new URLSearchParams();

    if (filtros.estado) {
      params.append("estado", filtros.estado);
    }

    if (filtros.soloPendientesDeAplicar) {
      params.append("soloPendientes", "true");
    }

    if (filtros.fechaInicio) {
      params.append("fechaInicio", filtros.fechaInicio);
    }

    if (filtros.fechaFin) {
      params.append("fechaFin", filtros.fechaFin);
    }

    if (filtros.ordenarDatos) {
      params.append("orden", filtros.ordenarDatos);
    }

    if (filtros.tipos?.length > 0) {
      params.append("tipos", filtros.tipos.join(","));
    }

    if (filtros.resumenesConDetalles != null) {
      params.append("resumenesConDetalles", filtros.resumenesConDetalles);
    }

    return params.toString();
  };

  const handleApplyResumen = (nuevosFiltros) => {
    setFiltros(nuevosFiltros);
    const params = buildQueryParams(nuevosFiltros);
    const url = `${UrlApi}/cuentaCorriente/${exportTipo}/${props.cliente.id}/${props.cliente.id_tipocliente}?${params}`;
    window.open(url, "_blank");
  };

  const getCantidadDeRecibosPendientes = () => {
    // console.log("COUNT: ", props.cliente);
    getData(
      `/ctacte/recibos/countPendientes/${props.cliente.id}/${props.cliente.id_tipocliente}`,
      setCantidadDeRecibosPendientes,
    );
  };

  const handleAplicarRecibo = (rowData) => {
    setShowAplicarReciboAFactura(true);
    const recibo = {
      id: rowData.id,
      fecha_de_pago: rowData.fecha_emision,
      total: rowData.importe_total,
      nro_recibo: rowData.nro_comprobante,
      saldo: rowData.saldoImputado,
    };
    setSelectedRow(recibo);
  };

  const estaVencidaConSaldoPendiente = (
    comprobante,
    fechaVencimiento,
    saldoPendiente,
  ) => {
    if (String(comprobante).toLocaleLowerCase() !== "factura") return false;
    return (
      saldoPendiente > 0 && new Date(fechaVencimiento).getTime() < Date.now()
    );
  };

  useEffect(() => {
    getDocuments();
    traerCantidadDeNotas();
    obtenerPermisos();
    getCantidadDeRecibosPendientes();
  }, [filtros]);

  // console.log("QUERY:", buildQueryParams(filtros));

  // const [confirmDialog, setConfirmDialog] = useState({
  //   open: false,
  // });

  const [notify, setNotify] = useState({
    open: false,
    severity: "",
    color: "",
    mensaje: "",
  });

  const buildRowActions = (row, closeMenu) => {
    const actions = [];
    const comprobante = row.comprobante?.toUpperCase();
    const isRecibo = comprobante === "RECIBO";
    const isNC = comprobante === "NOTA DE CREDITO";
    const isND = comprobante === "NOTA DE DEBITO";
    const isAjuste = comprobante === "AJUSTE CTACTE";
    const isFactura = !isRecibo && !isNC && !isND && !isAjuste;

    if (isAjuste) {
      actions.push(
        <MenuItem key="noOptions" disabled={true}>
          No hay opciones
        </MenuItem>,
      );
    }
    if (isFactura || isNC || isND) {
      actions.push(
        <MenuItem
          key="view"
          onClick={() => {
            closeMenu();
            verEnviarPDF(row.id, 0);
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon color="secondary" />
          </ListItemIcon>
          Visualizar
        </MenuItem>,
      );
      actions.push(
        <MenuItem
          key="mail"
          onClick={() => {
            closeMenu();
            handleResendByMail(row);
          }}
        >
          <ListItemIcon>
            <Mail color="primary" />
          </ListItemIcon>
          Reenviar por mail
        </MenuItem>,
      );
    }

    if (isFactura) {
      actions.push(
        <MenuItem
          key="view"
          disabled={row.estado === "Anulado"}
          onClick={() => {
            closeMenu();
            handleShowSaldoFacturas(row);
          }}
        >
          <ListItemIcon>
            <SummarizeIcon color="default" />
          </ListItemIcon>
          Ver saldo
        </MenuItem>,
      );
    }

    if (isFactura && canCancelInvoice) {
      actions.push(
        <MenuItem
          key="cancel"
          disabled={row.estado === "Anulado"}
          onClick={() => {
            closeMenu();
            handleShowAnularFacturaDialog(row);
          }}
        >
          <ListItemIcon>
            <DoDisturbOnIcon color="warning" />
          </ListItemIcon>
          Anular
        </MenuItem>,
      );
    }

    if (isRecibo) {
      actions.push(
        <MenuItem
          key="ver-recibo"
          onClick={() => {
            closeMenu();
            handleVerRecibo(row);
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon color="primary" />
          </ListItemIcon>
          Ver recibo
        </MenuItem>,
      );
      actions.push(
        <MenuItem
          key="ver-recibo"
          disabled={row.saldoImputado === 0}
          onClick={() => {
            closeMenu();
            //console.log("Recibo: ", row);
            handleAplicarRecibo(row);
          }}
        >
          <ListItemIcon>
            <AccountBalanceWalletIcon sx={{ color: "#631700 " }} />
          </ListItemIcon>
          Aplicar recibo
        </MenuItem>,
      );

      actions.push(
        <MenuItem
          key="anular-recibo"
          onClick={() => {
            closeMenu();
            handleShowCancelReceipt(row);
          }}
          disabled={row.estado === "Anulado"}
        >
          <ListItemIcon>
            <CancelIcon color="error" />
          </ListItemIcon>
          Anular recibo
        </MenuItem>,
      );

      actions.push(
        <MenuItem
          key="desaplicar-recibo"
          onClick={() => {
            closeMenu();
            // console.log("ROWDATA: ", row);
            handleShowDesaplicarRecibo(row);
          }}
        >
          <ListItemIcon>
            <Undo sx={{ color: "#F59E0B" }} />
          </ListItemIcon>
          Deshacer aplicación
        </MenuItem>,
      );
    }

    return actions;
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "fecha_emision",
        header: "Fecha",
        muiTableBodyCellProps: {
          align: "center",
        },
        maxSize: 50,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value) return "-";

          // Tomás solo la parte de la fecha, sin convertir timezone
          const dateStr = value.toString().split("T")[0];
          const [year, month, day] = dateStr.split("-");
          return `${day}/${month}/${year}`;
        },
        Footer: () => <Typography fontWeight={800}>TOTALES</Typography>,
      },
      { accessorKey: "origen", header: "Tipo", maxSize: 50 },
      {
        accessorKey: "nro_comprobante",
        header: "Comprobante",
        maxSize: 50,
        Cell: ({ cell, row }) => {
          const value = cell.getValue();
          const isCopied = copiedId === row.original.id;

          const handleCopy = () => {
            navigator.clipboard.writeText(value);
            setCopiedId(row.original.id);
            setTimeout(() => setCopiedId(null), 2000);
          };

          return (
            <Box sx={{ display: "inline-block" }}>
              <Tooltip
                open={isCopied}
                title="¡Copiado!"
                placement="right"
                arrow
              >
                <Typography
                  onClick={handleCopy}
                  sx={{
                    cursor: "pointer",
                    fontFamily: "'Inter', 'Roboto', sans-serif",
                    fontSize: "0.82rem",
                    fontWeight: 500,
                    letterSpacing: "0.03em",
                    "&:hover": {
                      textDecoration: "underline",
                      color: "primary.main",
                    },
                  }}
                >
                  {value}
                </Typography>
              </Tooltip>
            </Box>
          );
        },
      },
      {
        accessorKey: "fecha_vencimiento",
        header: "Vence el",
        muiTableBodyCellProps: {
          align: "center",
        },
        muiTableHeadCellProps: {
          align: "center",
        },
        maxSize: 50,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value || value === "0000-00-00") return "-";

          const dateStr = value.toString().split("T")[0];
          const [year, month, day] = dateStr.split("-");
          return `${day}/${month}/${year}`;
        },
      },
      {
        accessorKey: "saldoImputado",
        header: "Aplicado",
        size: 20,
        Cell: ({ row }) => {
          const saldoPendiente = Number(row.original.saldoImputado);
          const importeTotalDelComprobante = row.original.importe_total;
          const comprobante = row.original.comprobante.toLowerCase().trim();
          const estado = row.original.estado.toLowerCase().trim();
          if (
            saldoPendiente === importeTotalDelComprobante ||
            comprobante === "nota de credito" ||
            comprobante === "nota de debito" ||
            comprobante === "ajuste ctacte" ||
            estado === "anulado"
          )
            return null;

          return (
            <Chip
              label={`${saldoPendiente === 0 ? "Aplicado" : "Parcial"}`}
              size="small"
              sx={{
                height: 20,
                fontSize: "0.68rem",
                fontWeight: 700,
                borderRadius: "6px",
                backgroundColor: "rgba(245, 158, 11, 0.12)",
                color: "#B45309",
                border: "1px solid rgba(245, 158, 11, 0.25)",

                "& .MuiChip-label": {
                  px: 1,
                },
              }}
            />
          );
        },
      },
      {
        accessorKey: "debe",
        header: "Debe",
        muiTableBodyCellProps: {
          align: "right",
        },
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableFooterCellProps: {
          align: "right",
        },
        maxSize: 50,
        Cell: ({ cell }) => {
          const value = Number(cell.getValue());
          if (value === 0 || !value) return;

          return (
            <Typography
              sx={{
                color: "success.main",
                fontWeight: 600,
              }}
            >
              ${formatMoney(value)}
            </Typography>
          );
        },
        Footer: () => (
          <Typography sx={{ color: "success.main", fontWeight: 700 }}>
            ${formatMoney(totales.debe)}
          </Typography>
        ),
      },
      {
        accessorKey: "haber",
        header: "Haber",
        muiTableBodyCellProps: {
          align: "right",
        },
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableFooterCellProps: {
          align: "right",
        },
        maxSize: 50,
        Cell: ({ cell }) => {
          const value = Number(cell.getValue());
          if (value === 0 || !value) return;
          return (
            <Typography
              sx={{
                color: "error.main",
                fontWeight: 600,
              }}
            >
              ${formatMoney(value)}
            </Typography>
          );
        },
        Footer: () => (
          <Typography sx={{ color: "error.main", fontWeight: 700 }}>
            ${formatMoney(totales.haber)}
          </Typography>
        ),
      },
      {
        accessorKey: "saldo_cta_cte",
        header: "Saldo",
        muiTableBodyCellProps: {
          align: "right",
        },
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableFooterCellProps: {
          align: "right",
        },
        maxSize: 50,
        Cell: ({ cell }) => {
          const value = Number(cell.getValue());
          const color = value >= 0 ? "success.main" : "error.main";
          return (
            <Typography
              sx={{
                color: color,
                fontWeight: 600,
              }}
            >
              ${formatMoney(value)}
            </Typography>
          );
        },
        Footer: () => (
          <Typography
            sx={{
              color: totales.saldo > 0 ? "success.main" : "error.main",
              fontWeight: 700,
            }}
          >
            ${formatMoney(totales.saldo)}
          </Typography>
        ),
      },
      {
        accessorKey: "nro_remito",
        header: "N° Remito",
        maxSize: 50,
        muiTableBodyCellProps: {
          align: "right",
        },
        muiTableHeadCellProps: {
          align: "right",
        },
      },
    ],
    [totales.debe, totales.haber, totales.saldo, copiedId],
  );

  const filtrosActivos = [
    filtros.estado,
    filtros.soloPendientesDeAplicar,
    filtros.fechaInicio,
    filtros.fechaFin,
    filtros.tipos?.length > 0 ? filtros.tipos : null,
  ].filter(Boolean).length;

  // console.log(documents);

  // const handleCancelInvoice = (row) => {
  //   setSelectedRow(row);
  //   setConfirmDialog({
  //     open: true,
  //     color: "#ed710b",
  //     borderColor: "#ed710b",
  //     icon: <WarningAmberIcon sx={{ fontSize: 40 }} />,
  //     title: "ANULAR FACTURA",
  //     subtitle: (
  //       <Typography variant="subtitle1" color="initial">
  //         Se hará una <b>nota de crédito</b> por el total de la factura.
  //       </Typography>
  //     ),
  //     confirmText: "Presione 'confirmar' para guardar.",
  //     btnText: "Confirmar",
  //   });
  // };

  // async function issueCreditNote(e) {
  //   //issue en ingles es "emitir" (por las dudas aclaro).
  //   await enviarNC(selectedRow, setNotify, setConfirmDialog);
  //   getDocuments();
  // }

  const handleResendByMail = async (rowData) => {
    setSelectedRow(rowData);
    try {
      const response = await fetch(
        `${UrlApi}/comprobantes/direccionesDeEntrega/mails/${rowData.id}`,
      );
      if (!response.ok) throw new Error("Error al obtener los mails");

      const mails = await response.json();
      setMailCliente(mails);
      setShowResendEmailConfirm(true);
    } catch (err) {
      showToast?.("Error al obtener los mails del cliente", "error");
    }
  };

  const disabledNuevoComprobante = () => {
    return (
      !permisos?.filter((permiso) => permiso.funcion === "facturar")?.length > 0
    );
  };

  const formatMoney = (n) =>
    n || n === 0
      ? n.toLocaleString("es-AR", { minimumFractionDigits: 2 })
      : "-";

  const handleNuevaFactura = () => {
    setShowNewInvoiceDialog(true);
  };

  const handleNewReceipt = () => {
    setShowReceiptDialog(true);
  };

  const handleOpenNotes = () => {
    setShowNotesDialog(true);
  };

  const handleNewImputacion = () => {
    setShowNewImputacionDialog(true);
  };

  const handlePutMail = (e) => {
    putData(
      e,
      `/comprobantes/mail/${selectedRow.id}`,
      { enviadoxmail: 0 },
      setNotify,
    );
    logEventos(
      "Enviar por mail factura",
      "Cuentas corrientes",
      "Clientes",
      localStorage.getItem("user"),
    );
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        sx: {
          fontSize: 14,
          color: "black",
          fontWeight: "normal",
          paddingTop: 1,
          paddingBottom: 1,
          backgroundColor: bgColorTableHeadCell,
          borderColor: "#FDFEFE",
        },
      },
      size: 60,
    },
  };

  const handleVerRecibo = (recibo) => {
    setSelectedRecibo(recibo);
    setShowReciboDetalle(true);
  };

  const handleShowCancelReceipt = (recibo) => {
    setSelectedRecibo(recibo);
    setShowCancelReceiptsDialog(true);
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: {
      pageIndex: 0,
      pageSize: 100,
    },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 14,
      color: "black",
      fontWeight: "normal",
      paddingTop: 1,
      paddingBottom: 1,
      backgroundColor: bgColorTableHeadCell,
      borderColor: "#FDFEFE",
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const isNetizarOrCasaCentralUser =
    Number(localStorage.getItem("sucursal")) === 1000 ||
    Number(localStorage.getItem("sucursal")) === 8;
  const me = localStorage.getItem("user") === "Ibastianelli";

  return (
    <div>
      {verSoloPendientes ? (
        <CuentaCorrientePendientesPage
          idCliente={props.cliente.id}
          idTipoNegocio={props.cliente.id_tipocliente}
          onVolver={() => {
            getDocuments();
            setVerSoloPendientes(false);
          }}
          clienteData={props.cliente}
        />
      ) : (
        documents && (
          <>
            <Container maxWidth="xl" disableGutters>
              <Box boxShadow={3}>
                <MaterialReactTable
                  renderTopToolbarCustomActions={() => (
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                      {/* <Button
                        variant="outlined"
                        startIcon={<AddBoxTwoToneIcon />}
                        onClick={handleNuevaFactura}
                        disabled={disabledNuevoComprobante}
                        sx={{ borderRadius: 3 }}
                      >
                        Nuevo Comprobante
                      </Button> */}
                      {(isNetizarOrCasaCentralUser || me) && (
                        <>
                          <Button
                            variant="outlined"
                            color="success"
                            startIcon={<ReceiptLongIcon />}
                            onClick={handleNewReceipt}
                            sx={{ borderRadius: 3 }}
                          >
                            Cargar Recibo
                          </Button>

                          <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<AccountBalanceWalletIcon />}
                            onClick={handleNewImputacion}
                            sx={{ borderRadius: 3 }}
                          >
                            Aplicar Recibo
                          </Button>
                          <Button
                            variant="outlined"
                            color="warning"
                            startIcon={<PendingActionsIcon />}
                            sx={{ borderRadius: 3 }}
                            onClick={() => setVerSoloPendientes(true)}
                          >
                            Solo Pendientes
                          </Button>
                          <Button
                            variant="outlined"
                            startIcon={<FilterListIcon />}
                            onClick={handleShowModalDeFiltros}
                            sx={{ borderRadius: 3 }}
                          >
                            Filtros
                            {filtrosActivos > 0 && (
                              <Chip
                                label={filtrosActivos}
                                size="small"
                                color="primary"
                                sx={{ ml: 1, height: 20, fontSize: "0.7rem" }}
                              />
                            )}
                          </Button>
                          {filtrosActivos > 0 && (
                            <Button
                              variant="text"
                              size="small"
                              color="error"
                              startIcon={<CloseIcon />}
                              onClick={() => {
                                setFiltros({
                                  tipos: [],
                                  estado: null,
                                  soloPendientesDeAplicar: false,
                                  fechaInicio: null,
                                  fechaFin: null,
                                  ordenarDatos: "DESC",
                                  resumenesConDetalles: null,
                                });
                                showToast(
                                  "Filtros eliminados correctamente",
                                  "success",
                                );
                              }}
                            >
                              Limpiar filtros
                            </Button>
                          )}
                          <PendingReceiptsChip
                            count={cantidadDeRecibosPendientes}
                          />
                        </>
                      )}
                    </Box>
                  )}
                  renderBottomToolbarCustomActions={() => (
                    <Box sx={{ display: "flex", gap: 2, p: 1 }}>
                      <Button
                        variant="contained"
                        color="success"
                        onClick={handleExportExcel}
                        startIcon={<TableChartIcon />}
                      >
                        Exportar Excel
                      </Button>

                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleExportPdf}
                        startIcon={<PictureAsPdfIcon />}
                      >
                        Exportar PDF
                      </Button>
                      <Badge
                        badgeContent={contadorDeNotas}
                        color="error"
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <IconButton
                          onClick={handleOpenNotes}
                          sx={{
                            color: "#f4b400", // Amarillo Google
                            backgroundColor: "transparent",
                            "&:hover": {
                              backgroundColor: "rgba(244,180,0,0.08)",
                            },
                          }}
                        >
                          <StickyNote2Icon sx={{ fontSize: 28 }} />
                        </IconButton>
                      </Badge>
                    </Box>
                  )}
                  muiTableBodyRowProps={({ row }) => {
                    const { debe, haber } = row.original;

                    // console.log("ROWDATA: ", row.original);
                    let color = "inherit";

                    if (debe) color = "success.main";
                    if (haber) color = "error.main";

                    return {
                      sx: {
                        "& td": {
                          color,
                          fontWeight: 600,
                        },
                      },
                    };
                  }}
                  muiSearchTextFieldProps={muiSearchTextFieldProps}
                  localization={MRT_Localization_ES}
                  columns={columns}
                  data={documents}
                  enableSorting={false}
                  enableColumnFilterModes={false}
                  enableColumnOrdering={false}
                  enableGrouping={false}
                  enableRowActions
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "47vh",
                    },
                  }}
                  enableStickyFooter
                  enableStickyHeader
                  initialState={initialState}
                  enableRowSelection={false}
                  positionActionsColumn="last"
                  enableHiding={false}
                  muiTableHeadCellProps={tableHeadCellProps}
                  positionExpandColumn="first"
                  enableExpandAll={false}
                  muiTableFooterCellProps={{
                    sx: {
                      backgroundColor: bgColorTableHeadCell,
                      borderColor: "#FDFEFE",
                    },
                  }}
                  muiTableBodyCellProps={({ row }) => ({
                    align: "left",
                    sx: {
                      backgroundColor: estaVencidaConSaldoPendiente(
                        row.original.comprobante,
                        row.original.fecha_vencimiento,
                        row.original.saldoImputado,
                      )
                        ? row.index % 2 === 0
                          ? "#FEF3C7"
                          : "#ffeea8"
                        : row.index % 2 === 0
                          ? "#ffffff"
                          : "#fafafa",
                      color: "black",
                      borderBottom: "1px solid rgba(224,224,224,1)",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    },
                    hover: true,
                  })}
                  enableColumnActions={false}
                  enableColumnFilters={false}
                  displayColumnDefOptions={displayColumnDefOptions}
                  enableDensityToggle={false}
                  renderRowActionMenuItems={({ closeMenu, row }) =>
                    buildRowActions(row.original, closeMenu)
                  }
                />
              </Box>
              <br />
              <br />
              {selectedRow && (
                <DesaplicarFacturasModal
                  open={showAnularFacturaDialog}
                  onClose={() => setShowAnularFacturaDialog(false)}
                  datos={selectedRow}
                  idFactura={selectedRow?.id}
                  onSuccess={getDocuments}
                  showToast={showToast}
                />
              )}
              {showResendEmailConfirm ? (
                <ConfirmDialog
                  open={showResendEmailConfirm}
                  color={"#2ECC71"}
                  icon={iconCheck}
                  title={`Comprobante ${selectedRow.comprobante}  ${selectedRow.nro_comprobante}`}
                  subtitle={
                    <Typography>
                      Se enviará este comprobante al mail :{" "}
                      <strong>{mailCliente}</strong>
                    </Typography>
                  }
                  notify={notify}
                  setNotify={setNotify}
                  setOpen={setShowResendEmailConfirm}
                  guardar={handlePutMail}
                  btnText={"Confirmar"}
                />
              ) : null}
              {showNewInvoiceDialog && (
                <NewInvoiceDialog
                  dataCliente={props.cliente}
                  closeNewInvoiceDialog={() => {
                    setShowNewInvoiceDialog(false);
                    getDocuments();
                  }}
                  openNewInvoice={showNewInvoiceDialog}
                />
              )}
            </Container>
            <ReceiptDialog
              open={showReceiptDialog}
              onClose={() => {
                // console.log("Cerrando modal");
                getDocuments();
                getCantidadDeRecibosPendientes();
                setShowReceiptDialog(false);
              }}
              clienteData={props.cliente}
            />
            {/* Boton de aplicar recibo */}
            <SeleccionarRecibo
              open={showNewImputacionDialog}
              onClose={() => setShowNewImputacionDialog(false)}
              cuit={props.cliente?.cuit}
              getDocuments={getDocuments}
              clienteData={props.cliente}
              onSelect={(rec) => setSelectedRecibo(rec)}
            />
            {/* Action row para ver el saldo de una factura */}
            <SaldosFacturasModal
              open={showSaldoFactura}
              onClose={() => setShowSaldoFactura(false)}
              rowInfo={selectedRow}
              clienteData={props.cliente}
            />
            {/* action row que meti al final */}
            <ImputacionModal
              open={showAplicarReciboAFactura}
              onClose={() => setShowAplicarReciboAFactura(false)}
              mode="post"
              cuit={props.cliente.cuit || ""}
              recibo={selectedRow}
              clienteData={props.cliente}
              getDocuments={getDocuments}
              user={localStorage.getItem("user")}
              saldoDisponible={selectedRow?.saldo}
              // imputaciones={state.imputaciones}
              // onSetImputaciones={setImputaciones}
            />
            <NotasCuentaCorrienteModal
              open={showNotesDialog}
              onClose={() => {
                traerCantidadDeNotas();
                setShowNotesDialog(false);
              }}
              nombreCliente={props.cliente.razon_social}
              idCliente={props.cliente.id}
              envasado={0}
              refresh={traerCantidadDeNotas}
            />
            <ModalDeFiltros
              open={showModalDeFiltros}
              onClose={() => {
                setShowModalDeFiltros(false);
                setExportTipo(null);
              }}
              onApply={
                exportTipo
                  ? handleApplyResumen
                  : (newFiltros) => setFiltros(newFiltros)
              }
              filtros={filtros}
              setFiltros={setFiltros}
              showToast={showToast}
              showResumenOption={!!exportTipo}
            />
            {selectedRecibo && (
              <ReciboDetalleContainer
                open={showReciboDetalle}
                onClose={() => setShowReciboDetalle(false)}
                reciboId={selectedRecibo.id}
                clienteData={props.cliente}
              />
            )}
            {selectedRecibo && (
              <AnularRecibosModal
                open={showCancelReceiptsDialog}
                onClose={() => setShowCancelReceiptsDialog(false)}
                idRecibo={selectedRecibo.id}
                onSuccess={getDocuments}
                showToast={showToast}
              />
            )}
            {selectedRecibo && (
              <DesaplicarImputacionModal
                open={showDesaplicarRecibo}
                onClose={() => setShowDesaplicarRecibo(false)}
                idRecibo={selectedRecibo.id}
                onSuccess={getDocuments}
                showToast={showToast}
                getDocuments={getDocuments}
              />
            )}
          </>
        )
      )}
      {Toast}
    </div>
  );
}

export default Comprobantes;
